import { orderBy } from "lodash";
import React from "react";

import {
  IgAutocomplete,
  IgStatusCircle,
  IgTypography,
} from "@intelligems/ig-theme";
import { Grid, TextField } from "@mui/material";

import { useGetThemes } from "../../api/shopify-themes/get-themes";

interface SelectThemeProps {
  isDisabled?: boolean;
  fullWidth?: boolean;
  value: string;
  defaultLive?: boolean;
  minWidth?: string;
  maxWidth?: string;
  onChange: (value: string) => void;
}

export const SelectTheme = ({
  isDisabled,
  fullWidth,
  value,
  defaultLive,
  onChange,
  minWidth,
  maxWidth,
}: SelectThemeProps) => {
  const themes = useGetThemes();
  if (themes.isSuccess && themes.data.themes) {
    const foundValue = themes.data.themes.find(
      (theme) => String(theme.id) === value
    );
    return (
      <IgAutocomplete
        disabled={isDisabled}
        disablePortal
        onChange={(e, newValue) => {
          onChange(String(newValue.id));
        }}
        isOptionEqualToValue={(option, value) => option.id === value.id}
        id="select-theme"
        options={orderBy(
          Object.values(themes.data?.themes || []),
          [(_) => (_.role === "main" ? "1" : "0"), (_) => Number(_.updatedAt)],
          ["desc", "desc"]
        )}
        value={foundValue ? foundValue : value ? value : ""}
        fullWidth={fullWidth}
        disableClearable={true}
        renderInput={(params) => {
          return <TextField {...params} />;
        }}
        getOptionLabel={(option) =>
          !option ? "" : `${option.name} (${option.id})`
        }
        renderOption={(props, option) => {
          return (
            <li {...props} key={option.value}>
              <Grid
                container
                direction={"row"}
                alignContent={"center"}
                columnSpacing={2}
              >
                {option.role === "main" ? (
                  <Grid item sx={{ marginTop: "6px" }}>
                    <IgStatusCircle status={"success"} />
                  </Grid>
                ) : null}
                <Grid item sx={{ overflowX: "hidden" }}>
                  <IgTypography>
                    {option.name} ({option.id})
                  </IgTypography>
                </Grid>
              </Grid>
            </li>
          );
        }}
      />
    );
  }
  return null;
};
